import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import PublicLayout from '../../components/layout/PublicLayout';
import Button from '../../components/common/Button';
import Icon from '../../components/common/Icon';
import { authAPI } from '../../services/api';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [submitting, setSubmitting] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  
  const { state } = location;
  const role = state?.role || 'BUYER';

  console.log(role);
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm();

  const onSubmit = async (data) => {
    setSubmitting(true);
    
    try {
      await authAPI.forgotPassword(data.email);
      setEmailSent(true);
      navigate('/verify-otp', {
        state: {
          email: data.email,
          role: role.toUpperCase(),
          otpType: 'PASSWORD_RESET'
        }
      });
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Failed to send reset instructions';
      toast.error(errorMessage);
    } finally {
      setSubmitting(false);
    }
  };

  if (emailSent) {
    return (
      <PublicLayout title="Reset Password" showBack>
        <div style={{ maxWidth: '400px', margin: '0 auto' }}>
          <div className="card">
            <div style={{ textAlign: 'center', padding: '32px 0' }}>
              <div style={{
                width: '64px',
                height: '64px',
                background: 'var(--success-light)',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 16px'
              }}>
                <Icon name="mail" size={32} color="var(--success)" />
              </div>
              <h3 style={{
                fontFamily: 'Outfit, sans-serif',
                fontWeight: '700',
                fontSize: '20px',
                color: 'var(--text)',
                marginBottom: '8px'
              }}>
                Check Your Email
              </h3>
              <p style={{ fontSize: '14px', color: 'var(--text-muted)', marginBottom: '24px' }}>
                We've sent password reset instructions to your email address.
              </p>
              <Button
                variant="secondary"
                size="md"
                onClick={() => navigate('/login', { state: { role } })}
                style={{ width: '100%' }}
              >
                Back to Login
              </Button>
            </div>
          </div>
        </div>
      </PublicLayout>
    );
  }

  return (
    <PublicLayout title="Reset Password" showBack>
      <div style={{ maxWidth: '400px', margin: '0 auto' }}>
        <div className="card">
          {/* Header */}
          <div style={{ textAlign: 'center', marginBottom: '32px' }}>
            <h2 style={{
              fontFamily: 'Outfit, sans-serif',
              fontWeight: '700',
              fontSize: '24px',
              color: 'var(--text)',
              marginBottom: '8px'
            }}>
              Reset Password
            </h2>
            <p style={{ fontSize: '14px', color: 'var(--text-muted)' }}>
              Enter your email address and we'll send you instructions to reset your password.
            </p>
          </div>

          {/* Form */}
          <form onSubmit={handleSubmit(onSubmit)} style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
            {/* Email */}
            <div>
              <label className="label">Email Address *</label>
              <input
                {...register('email', { 
                  required: 'Email is required',
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: 'Invalid email address'
                  }
                })}
                type="email"
                placeholder="Enter your email address"
                style={{
                  width: '100%',
                  borderColor: errors.email ? 'var(--red)' : 'var(--border)'
                }}
              />
              {errors.email && (
                <p className="text-red-500">{errors.email.message}</p>
              )}
            </div>

            {/* Submit Button */}
            <Button
              type="submit"
              variant="primary"
              size="md"
              loading={submitting}
              style={{ width: '100%', padding: '12px' }}
            >
              Send Reset Instructions
            </Button>

            {/* Back to Login */}
            <div style={{ textAlign: 'center' }}>
              <button
                type="button"
                onClick={() => navigate('/login', { state: { role } })}
                style={{
                  background: 'none',
                  border: 'none',
                  color: 'var(--primary)',
                  fontSize: '14px',
                  cursor: 'pointer'
                }}
              >
                ← Back to Login
              </button>
            </div>
          </form>
        </div>
      </div>
    </PublicLayout>
  );
};

export default ForgotPassword;
